module.exports = __webpack_public_path__ + "static/originell-bfd970a823d69811e4be380894c4ec75.png";